export default "__VITE_ASSET__ftMB0tOQ__"